import user from "@/store/modules/user/user";
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    user
  }
});
export default store



// WEBPACK FOOTER //
// ./src/store/index.js